export const OfflineSessionConstants = {
    sessionExpirationCookieName: "LiNK-Session-Expires",
};
